// ./src/components/generic/form/TextField.tsx
//
// TextInput wrapper on the shared `(name, value)` change contract. Size/label
// styling come from the theme (md by default) so callers never repeat `size`.

import React from 'react';
import { TextInput, TextInputProps } from '@mantine/core';

import { FieldChangeHandler } from './types';

export interface TextFieldProps extends Omit<TextInputProps, 'onChange' | 'value'> {
  name?: string;
  value?: string | null;
  onChange?: FieldChangeHandler<string>;
}

// forwardRef so callers can grab the underlying <input> — e.g. to autofocus the
// first field of a drawer/modal (see the em-scaffold-ui autofocus pattern).
export const TextField = React.forwardRef<HTMLInputElement, TextFieldProps>(
  ({ name, value, onChange, ...rest }, ref) => (
    <TextInput
      ref={ref}
      name={name}
      value={value ?? ''}
      onChange={(e) => onChange?.(name, e.currentTarget.value)}
      {...rest}
    />
  ),
);

TextField.displayName = 'TextField';
